import { jobLists } from "character";
import { EorzeaDataType, GameData, Job, Market, RelicData } from "enums";
import { Info } from "types/game";

export const hwItems = {
	[GameData.Item.LUMINOUS_WIND_CRYSTAL]: {
		name: GameData.Item.LUMINOUS_WIND_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.SEA_OF_CLOUDS] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMATED, RelicData.Step.CRYSTALS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LUMINOUS_FIRE_CRYSTAL]: {
		name: GameData.Item.LUMINOUS_FIRE_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.AZYS_LLA] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMATED, RelicData.Step.CRYSTALS, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LUMINOUS_LIGHTNING_CRYSTAL]: {
		name: GameData.Item.LUMINOUS_LIGHTNING_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.CHURNING_MISTS] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMATED, RelicData.Step.CRYSTALS, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LUMINOUS_ICE_CRYSTAL]: {
		name: GameData.Item.LUMINOUS_ICE_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.COERTHAS_WESTERN_HIGHLANDS] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMATED, RelicData.Step.CRYSTALS, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LUMINOUS_EARTH_CRYSTAL]: {
		name: GameData.Item.LUMINOUS_EARTH_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.DRAVANIAN_FORELANDS] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMATED, RelicData.Step.CRYSTALS, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.LUMINOUS_WATER_CRYSTAL]: {
		name: GameData.Item.LUMINOUS_WATER_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.MapLocation.DRAVANIAN_HINTERLANDS] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMATED, RelicData.Step.CRYSTALS, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.UNIDENTIFIABLE_BONE]: {
		name: GameData.Item.UNIDENTIFIABLE_BONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.SABINA, cost: [{ price: 3, currency: GameData.Currency.GORDIAN_BOLT }] },
				{ shop: GameData.Shop.LUNA_VANU, cost: [{ price: 6, currency: GameData.Currency.VANU_WHITEBONE }] },
				{ shop: GameData.Shop.AMALJAA_VENDOR, cost: [{ price: 3, currency: GameData.Currency.STEEL_AMALJOK }] },
				{ shop: GameData.Shop.VATH_STICKPEDDLER, cost: [{ price: 6, currency: GameData.Currency.BLACK_COPPER_GIL }] },
				{ shop: GameData.Shop.MOGMUL_MOGBELLY, cost: [{ price: 18, currency: GameData.Currency.KUPO_NUT }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMA, RelicData.Step.RUBBER, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 10,
			},
		],
	},
	[GameData.Item.UNIDENTIFIABLE_SHELL]: {
		name: GameData.Item.UNIDENTIFIABLE_SHELL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.SABINA, cost: [{ price: 3, currency: GameData.Currency.GORDIAN_LENS }] },
				{ shop: GameData.Shop.LUNA_VANU, cost: [{ price: 6, currency: GameData.Currency.VANU_WHITEBONE }] },
				{ shop: GameData.Shop.AMALJAA_VENDOR, cost: [{ price: 3, currency: GameData.Currency.STEEL_AMALJOK }] },
				{ shop: GameData.Shop.VATH_STICKPEDDLER, cost: [{ price: 6, currency: GameData.Currency.BLACK_COPPER_GIL }] },
				{ shop: GameData.Shop.MOGMUL_MOGBELLY, cost: [{ price: 18, currency: GameData.Currency.KUPO_NUT }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMA, RelicData.Step.CARBONCOAT, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 10,
			},
		],
	},
	[GameData.Item.UNIDENTIFIABLE_ORE]: {
		name: GameData.Item.UNIDENTIFIABLE_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.SABINA, cost: [{ price: 3, currency: GameData.Currency.GORDIAN_SPRING }] },
				{ shop: GameData.Shop.LUNA_VANU, cost: [{ price: 6, currency: GameData.Currency.VANU_WHITEBONE }] },
				{ shop: GameData.Shop.AMALJAA_VENDOR, cost: [{ price: 3, currency: GameData.Currency.STEEL_AMALJOK }] },
				{ shop: GameData.Shop.VATH_STICKPEDDLER, cost: [{ price: 6, currency: GameData.Currency.BLACK_COPPER_GIL }] },
				{ shop: GameData.Shop.MOGMUL_MOGBELLY, cost: [{ price: 18, currency: GameData.Currency.KUPO_NUT }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMA, RelicData.Step.WATER, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 10,
			},
		],
	},
	[GameData.Item.UNIDENTIFIABLE_SEEDS]: {
		name: GameData.Item.UNIDENTIFIABLE_SEEDS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 150, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_ULDAH, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_GRIDANIA, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.HUNT_BILLMASTER_LIMSA, cost: [{ price: 399, currency: GameData.Currency.ALLIED_SEAL }] },
				{ shop: GameData.Shop.SABINA, cost: [{ price: 3, currency: GameData.Currency.GORDIAN_SHAFT }] },
				{ shop: GameData.Shop.LUNA_VANU, cost: [{ price: 6, currency: GameData.Currency.VANU_WHITEBONE }] },
				{ shop: GameData.Shop.AMALJAA_VENDOR, cost: [{ price: 3, currency: GameData.Currency.STEEL_AMALJOK }] },
				{ shop: GameData.Shop.VATH_STICKPEDDLER, cost: [{ price: 6, currency: GameData.Currency.BLACK_COPPER_GIL }] },
				{ shop: GameData.Shop.MOGMUL_MOGBELLY, cost: [{ price: 18, currency: GameData.Currency.KUPO_NUT }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMA, RelicData.Step.CATALYST, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 10,
			},
		],
	},
	[GameData.Item.ADAMANTITE_FRANCESCA]: {
		name: GameData.Item.ADAMANTITE_FRANCESCA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ADAMANTITE_FRANCESCA,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 60,
					lodestoneID: "034f122df22",
					itemsRequired: [
						{ item: GameData.Item.PTERODACTYL_STRAP, qty: 1 },
						{ item: GameData.Item.ADAMANTITE_NUGGET, qty: 1 },
						{ item: GameData.Item.BIRCH_LUMBER, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 13589 },
			shops: [
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMA, RelicData.Step.RUBBER, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 4,
			},
		],
	},
	[GameData.Item.TITANIUM_ALLOY_MIRROR]: {
		name: GameData.Item.TITANIUM_ALLOY_MIRROR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.TITANIUM_ALLOY_MIRROR,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 60,
					lodestoneID: "5a1aea9bcf7",
					itemsRequired: [
						{ item: GameData.Item.TITANIUM_ALLOY_SQUARE, qty: 1 },
						{ item: GameData.Item.HOLY_WATER, qty: 1 },
						{ item: GameData.Item.HARDSILVER_SAND, qty: 1 },
						{ item: GameData.Item.VITRIOL, qty: 1 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 13591 },
			shops: [
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMA, RelicData.Step.CARBONCOAT, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 4,
			},
		],
	},
	[GameData.Item.DISPELLING_ARROW]: {
		name: GameData.Item.DISPELLING_ARROW,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DISPELLING_ARROW,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 60,
					lodestoneID: "977e3df8bb2",
					itemsRequired: [
						{ item: GameData.Item.BLESSED_FLETCHINGS, qty: 1 },
						{ item: GameData.Item.HALLOWED_CHESTNUT_LUMBER, qty: 1 },
						{ item: GameData.Item.HARDSILVER_NUGGET, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 13593 },
			shops: [
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMA, RelicData.Step.WATER, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 4,
			},
		],
	},
	[GameData.Item.KINGCAKE]: {
		name: GameData.Item.KINGCAKE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.KINGCAKE,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 60,
					lodestoneID: "2292b5ff258",
					itemsRequired: [
						{ item: GameData.Item.MOOGLE_MINIATURE, qty: 1 },
						{ item: GameData.Item.HIGHLAND_FLOUR, qty: 1 },
						{ item: GameData.Item.YAK_MILK, qty: 1 },
						{ item: GameData.Item.OKEANIS_EGG, qty: 1 },
						{ item: GameData.Item.BIRCH_SYRUP, qty: 1 },
						{ item: GameData.Item.TINY_CROWN, qty: 1 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 1 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 13595 },
			shops: [
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 5000, currency: GameData.Currency.COMPANY_SEAL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_ANIMA, RelicData.Step.CATALYST, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 4,
			},
		],
	},
	[GameData.Item.AETHER_OIL]: {
		name: GameData.Item.AETHER_OIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 350, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 350, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 350, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 350, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 350, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 350, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_HYPERCONDUCTIVE, RelicData.Step.OIL_HYPER, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.CRYSTAL_SAND]: {
		name: GameData.Item.CRYSTAL_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Hand in any of the following groups of items for 2x Crystal Sand" },
				{ element: "li", text: "5x Rowena's Token (Blue Crafters' Scrip)" },
				{ element: "br" },
				{ element: "li", text: "5x Rowena's Token (Blue Gatherers' Scrip)" },
				{ element: "br" },
				{ element: "li", text: "1x Garlond Steel, 1x Celestine, 1x High Allagan Chimera Leather" },
				{ element: "br" },
				{ element: "li", text: "1x Amber-encased Vilekin" },
				{ element: "br" },
				{ element: "li", text: "3x Battlecraft Demimateria I" },
				{ element: "li", text: "2x Battlecraft Demimateria II" },
				{ element: "li", text: "3x Fieldcraft Demimateria I" },
				{ element: "li", text: "2x Fieldcraft Demimateria II" },
				{ element: "br" },
				{ element: "li", text: "5x Moonstone" },
				{ element: "br" },
				{ element: "li", text: "1x Inferno Horn" },
				{ element: "li", text: "1x Crag Heart" },
				{ element: "li", text: "1x Diamond Tear" },
				{ element: "br" },
				{ element: "li", text: "1x Vortex Feather" },
				{ element: "li", text: "1x Barb of the Whorl" },
				{ element: "li", text: "1x Large Levin Orb" },
				{ element: "br" },
				{ element: "li", text: "5x Superior Enchanted Ink" },
				{ element: "li", text: "5x Thavnairian Mist" },
				{ element: "br" },
				{ element: "li", text: "2x Mhachi Farthing" },
				{ element: "li", text: "5x Allagan Catalyst" },
				{ element: "br" },
				{ element: "li", text: "1x Unidentifiable Bone" },
				{ element: "li", text: "1x Unidentifiable Shell" },
				{ element: "li", text: "1x Unidentifiable Ore" },
				{ element: "li", text: "1x Unidentifiable Seeds" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_RECONDITIONED, RelicData.Step.SAND, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.UMBRITE]: {
		name: GameData.Item.UMBRITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 75, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 75, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 75, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 75, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 75, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 75, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_RECONDITIONED, RelicData.Step.SAND, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.SINGING_CLUSTER]: {
		name: GameData.Item.SINGING_CLUSTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 40, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 40, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 40, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 40, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 40, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 40, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
			quests: [GameData.Quest.SEEKING_INSPIRATION, GameData.Quest.CUT_FROM_DIFFERENT_CLOTH],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_SHARPENED, RelicData.Step.CLUSTERS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 50,
			},
		],
	},
	[GameData.Item.PNEUMITE]: {
		name: GameData.Item.PNEUMITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 100, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 100, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 100, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 100, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 100, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 100, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 4000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 4000, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 4000, currency: GameData.Currency.COMPANY_SEAL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_COMPLETE, RelicData.Step.PNEUMITE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 15,
			},
		],
	},
	[GameData.Item.AETHERIC_DENSITY]: {
		name: GameData.Item.AETHERIC_DENSITY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Aetheric Density points can be gained by the following" },
				{ element: "li", text: "HW Dungeons" },
				{ element: "li", text: "HW Trials" },
				{ element: "li", text: "HW Raids" },
				{ element: "li", text: "HW FATEs" },
				{ element: "li", text: "Level 50 ARR Dungeons, except MSQ" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_COMPLETE, RelicData.Step.DENSITY, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 2000,
			},
		],
	},
	[GameData.Item.ARCHAIC_ENCHANTED_INK]: {
		name: GameData.Item.ARCHAIC_ENCHANTED_INK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_ANIMA, RelicData.Part.WEAPON_LUX, RelicData.Step.BFF, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.PTERODACTYL_STRAP]: {
		name: GameData.Item.PTERODACTYL_STRAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 13590 },
			recipes: [
				{
					itemMade: GameData.Item.PTERODACTYL_STRAP,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 60,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.PTERODACTYL, qty: 1 },
						{ item: GameData.Item.DARK_CHESTNUT_LOG, qty: 1 },
						{ item: GameData.Item.DAWNBORNE_AETHERSAND, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 1 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 2 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.ADAMANTITE_NUGGET]: {
		name: GameData.Item.ADAMANTITE_NUGGET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12526 },
			recipes: [
				{
					itemMade: GameData.Item.ADAMANTITE_NUGGET,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 58,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ADAMANTITE_ORE, qty: 5 },
						{ item: GameData.Item.DARKSTEEL_ORE, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 5 },
					],
				},
				{
					itemMade: GameData.Item.ADAMANTITE_NUGGET,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 58,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ADAMANTITE_ORE, qty: 5 },
						{ item: GameData.Item.DARKSTEEL_ORE, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 5 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SCRAP_SALVAGER, cost: [{ price: 2958, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.BIRCH_LUMBER]: {
		name: GameData.Item.BIRCH_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12583 },
			recipes: [
				{
					itemMade: GameData.Item.BIRCH_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 58,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.BIRCH_LOG, qty: 5 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 5 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SCRAP_SALVAGER, cost: [{ price: 2958, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.TITANIUM_ALLOY_SQUARE]: {
		name: GameData.Item.TITANIUM_ALLOY_SQUARE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 13592 },
			recipes: [
				{
					itemMade: GameData.Item.TITANIUM_ALLOY_SQUARE,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 60,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.SPHALERITE, qty: 2 },
						{ item: GameData.Item.TITANIUM_NUGGET, qty: 1 },
						{ item: GameData.Item.DAWNBORNE_AETHERSAND, qty: 1 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 1 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.HOLY_WATER]: {
		name: GameData.Item.HOLY_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12604 },
			recipes: [
				{
					itemMade: GameData.Item.HOLY_WATER,
					qtyMade: 3,
					crafter: Job.ALC,
					level: 52,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DRAVANIAN_SPRING_WATER, qty: 2 },
						{ item: GameData.Item.DRAVANIAN_MISTLETOE, qty: 2 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 3 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SCRAP_SALVAGER, cost: [{ price: 2236, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.HARDSILVER_SAND]: {
		name: GameData.Item.HARDSILVER_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12532 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.LANDLORD_COLONY, x: 28, y: 19 } }],
			shops: [{ shop: GameData.Shop.MOGMUL_MOGBELLY, cost: [{ price: 807, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.VITRIOL]: {
		name: GameData.Item.VITRIOL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5490 },
			shops: [{ shop: GameData.Shop.KOBOLD_VENDOR, cost: [{ price: 216, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.BLESSED_FLETCHINGS]: {
		name: GameData.Item.BLESSED_FLETCHINGS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 13594 },
			recipes: [
				{
					itemMade: GameData.Item.BLESSED_FLETCHINGS,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 60,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ROYAL_MISTLETOE, qty: 2 },
						{ item: GameData.Item.EAGLE_FEATHER, qty: 1 },
						{ item: GameData.Item.DAWNBORNE_AETHERSAND, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 1 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.HALLOWED_CHESTNUT_LUMBER]: {
		name: GameData.Item.HALLOWED_CHESTNUT_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12582 },
			recipes: [
				{
					itemMade: GameData.Item.HALLOWED_CHESTNUT_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 56,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARK_CHESTNUT_LUMBER, qty: 1 },
						{ item: GameData.Item.HALLOWED_WATER, qty: 2 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 5 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SCRAP_SALVAGER, cost: [{ price: 2688, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.HARDSILVER_NUGGET]: {
		name: GameData.Item.HARDSILVER_NUGGET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12520 },
			recipes: [
				{
					itemMade: GameData.Item.HARDSILVER_NUGGET,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 54,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.HARDSILVER_SAND, qty: 5 },
						{ item: GameData.Item.SILVER_ORE, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 4 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SCRAP_SALVAGER, cost: [{ price: 2962, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.MOOGLE_MINIATURE]: {
		name: GameData.Item.MOOGLE_MINIATURE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 13596 },
			recipes: [
				{
					itemMade: GameData.Item.MOOGLE_MINIATURE,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 60,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CLOUD_COTTON_BOLL, qty: 2 },
						{ item: GameData.Item.BLACK_SOIL, qty: 1 },
						{ item: GameData.Item.DAWNBORNE_AETHERSAND, qty: 1 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 1 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.HIGHLAND_FLOUR]: {
		name: GameData.Item.HIGHLAND_FLOUR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12881 },
			recipes: [
				{
					itemMade: GameData.Item.HIGHLAND_FLOUR,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 52,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.HIGHLAND_WHEAT, qty: 6 },
						{ item: GameData.Item.FIRE_SHARD, qty: 7 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.YAK_MILK]: {
		name: GameData.Item.YAK_MILK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12888 },
			enemies: [GameData.Enemy.WOOLY_YAK],
			shops: [{ shop: GameData.Shop.VRAL, cost: [{ price: 617, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.OKEANIS_EGG]: {
		name: GameData.Item.OKEANIS_EGG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12872 },
			enemies: [GameData.Enemy.OKEANIS],
		},
		used: [],
	},
	[GameData.Item.BIRCH_SYRUP]: {
		name: GameData.Item.BIRCH_SYRUP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12892 },
			recipes: [
				{
					itemMade: GameData.Item.BIRCH_SYRUP,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 59,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.BIRCH_SAP, qty: 3 },
						{ item: GameData.Item.FIRE_SHARD, qty: 8 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.TINY_CROWN]: {
		name: GameData.Item.TINY_CROWN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5590 },
			shops: [{ shop: GameData.Shop.JOSSY, cost: [{ price: 150, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.HAMMERHEAD_SHARK]: {
		name: GameData.Item.HAMMERHEAD_SHARK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4893 },
			fishingHoles: [
				{
					fish: GameData.Fish.HAMMERHEAD_SHARK,
					hole: GameData.Fishing.HALFSTONE,
					bait: [
						GameData.Bait.HEAVY_STEEL_JIG,
						GameData.Bait.STEEL_JIG,
						GameData.Bait.SINKING_MINNOW,
						GameData.Bait.YUMIZUNO,
						GameData.Bait.NORTHERN_KRILL,
						GameData.Bait.SPOON_WORM,
						GameData.Bait.VERSATILE_LURE,
						GameData.Bait.KRILL_CAGE_FEEDER,
					],
				},
				{
					fish: GameData.Fish.HAMMERHEAD_SHARK,
					hole: GameData.Fishing.SILVER_BAZAAR,
					bait: [
						GameData.Bait.SHRIMP_CAGE_FEEDER,
						GameData.Bait.SPOON_WORM,
						GameData.Bait.SINKING_MINNOW,
						GameData.Bait.HEAVY_STEEL_JIG,
						GameData.Bait.STEEL_JIG,
						GameData.Bait.KRILL_CAGE_FEEDER,
						GameData.Bait.YUMIZUNO,
						GameData.Bait.NORTHERN_KRILL,
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.SILVER_SHARK]: {
		name: GameData.Item.SILVER_SHARK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 4903 },
			fishingHoles: [
				{
					fish: GameData.Fish.SILVER_SHARK,
					hole: GameData.Fishing.CAPE_WESTWIND,
					mooch: [
						[
							{
								fish: GameData.Fish.MERLTHOR_GOBY,
								bait: [
									GameData.Bait.LUGWORM,
									GameData.Bait.PILL_BUG,
									GameData.Bait.GOBY_BALL,
									GameData.Bait.RAT_TAIL,
									GameData.Bait.FLOATING_MINNOW,
									GameData.Bait.KRILL_CAGE_FEEDER,
									GameData.Bait.HEAVY_STEEL_JIG,
									GameData.Bait.NORTHERN_KRILL,
									GameData.Bait.VERSATILE_LURE,
								],
							},
						],
						[
							{
								fish: GameData.Fish.MERLTHOR_GOBY,
								bait: [
									GameData.Bait.LUGWORM,
									GameData.Bait.PILL_BUG,
									GameData.Bait.GOBY_BALL,
									GameData.Bait.RAT_TAIL,
									GameData.Bait.FLOATING_MINNOW,
									GameData.Bait.KRILL_CAGE_FEEDER,
									GameData.Bait.HEAVY_STEEL_JIG,
									GameData.Bait.NORTHERN_KRILL,
									GameData.Bait.VERSATILE_LURE,
								],
							},
							{ fish: GameData.Fish.WHAOO }, // Mooched from Goby
						],
					],
				},
				{
					fish: GameData.Fish.SILVER_SHARK,
					hole: GameData.Fishing.COSTA_DEL_SOL,
					mooch: [
						[
							{
								fish: GameData.Fish.FULLMOON_SARDINE,
								bait: [GameData.Bait.SPOON_WORM, GameData.Bait.STEEL_JIG, GameData.Bait.SINKING_MINNOW, GameData.Bait.HEAVY_STEEL_JIG, GameData.Bait.SALTWATER_BOILIE, GameData.Bait.VERSATILE_LURE],
							},
						],
					],
				},
				{
					fish: GameData.Fish.SILVER_SHARK,
					hole: GameData.Fishing.UMBRA_NORTHSHORE,
					mooch: [
						[
							{
								fish: GameData.Fish.MERLTHOR_GOBY,
								bait: [
									GameData.Bait.LUGWORM,
									GameData.Bait.PILL_BUG,
									GameData.Bait.GOBY_BALL,
									GameData.Bait.RAT_TAIL,
									GameData.Bait.FLOATING_MINNOW,
									GameData.Bait.KRILL_CAGE_FEEDER,
									GameData.Bait.HEAVY_STEEL_JIG,
									GameData.Bait.NORTHERN_KRILL,
									GameData.Bait.VERSATILE_LURE,
								],
							},
						],
						[
							{
								fish: GameData.Fish.FULLMOON_SARDINE,
								bait: [GameData.Bait.SPOON_WORM, GameData.Bait.STEEL_JIG, GameData.Bait.SINKING_MINNOW, GameData.Bait.HEAVY_STEEL_JIG, GameData.Bait.SALTWATER_BOILIE, GameData.Bait.VERSATILE_LURE],
							},
						],
						[
							{
								fish: GameData.Fish.MERLTHOR_GOBY,
								bait: [
									GameData.Bait.LUGWORM,
									GameData.Bait.PILL_BUG,
									GameData.Bait.GOBY_BALL,
									GameData.Bait.RAT_TAIL,
									GameData.Bait.FLOATING_MINNOW,
									GameData.Bait.KRILL_CAGE_FEEDER,
									GameData.Bait.HEAVY_STEEL_JIG,
									GameData.Bait.NORTHERN_KRILL,
									GameData.Bait.VERSATILE_LURE,
								],
							},
							{ fish: GameData.Fish.WHAOO }, // Mooched from Goby
						],
					],
				},
				{
					fish: GameData.Fish.SILVER_SHARK,
					hole: GameData.Fishing.SOUTH_BLOODSHORE,
					mooch: [
						[
							{
								fish: GameData.Fish.MERLTHOR_GOBY,
								bait: [
									GameData.Bait.LUGWORM,
									GameData.Bait.PILL_BUG,
									GameData.Bait.GOBY_BALL,
									GameData.Bait.RAT_TAIL,
									GameData.Bait.FLOATING_MINNOW,
									GameData.Bait.KRILL_CAGE_FEEDER,
									GameData.Bait.HEAVY_STEEL_JIG,
									GameData.Bait.NORTHERN_KRILL,
									GameData.Bait.VERSATILE_LURE,
								],
							},
						],
						[
							{
								fish: GameData.Fish.FULLMOON_SARDINE,
								bait: [
									GameData.Bait.SPOON_WORM,
									GameData.Bait.STEEL_JIG,
									GameData.Bait.SINKING_MINNOW,
									GameData.Bait.HEAVY_STEEL_JIG,
									GameData.Bait.SALTWATER_BOILIE,
									GameData.Bait.VERSATILE_LURE,
								],
							},
						],
					],
				},
				{
					fish: GameData.Fish.SILVER_SHARK,
					hole: GameData.Fishing.SUMMERFORD,
					mooch: [
						[
							{
								fish: GameData.Fish.MERLTHOR_GOBY,
								bait: [
									GameData.Bait.LUGWORM,
									GameData.Bait.PILL_BUG,
									GameData.Bait.GOBY_BALL,
									GameData.Bait.RAT_TAIL,
									GameData.Bait.FLOATING_MINNOW,
									GameData.Bait.KRILL_CAGE_FEEDER,
									GameData.Bait.HEAVY_STEEL_JIG,
									GameData.Bait.NORTHERN_KRILL,
									GameData.Bait.VERSATILE_LURE,
								],
							},
						],
						[
							{
								fish: GameData.Fish.HARBOR_HERRING,
								bait: [GameData.Bait.PILL_BUG, GameData.Bait.GOBY_BALL, GameData.Bait.RAT_TAIL, GameData.Bait.STEEL_JIG, GameData.Bait.FLOATING_MINNOW],
							},
						],
						[
							{
								fish: GameData.Fish.HARBOR_HERRING,
								bait: [GameData.Bait.PILL_BUG, GameData.Bait.GOBY_BALL, GameData.Bait.RAT_TAIL, GameData.Bait.STEEL_JIG, GameData.Bait.FLOATING_MINNOW],
							},
							{ fish: GameData.Fish.ORGRE_BARRACUDA },
						],
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.PTERODACTYL]: {
		name: GameData.Item.PTERODACTYL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 13733 },
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_OCEAN_FISHING, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 20, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
			],
		},
		used: [],
	},
	[GameData.Item.DARK_CHESTNUT_LOG]: {
		name: GameData.Item.DARK_CHESTNUT_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12578 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.SMOLDERING_WASTES, x: 26, y: 27 } }],
		},
		used: [],
	},
	[GameData.Item.DAWNBORNE_AETHERSAND]: {
		name: GameData.Item.DAWNBORNE_AETHERSAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12937 },
			reduction: [GameData.Item.BRIGHT_FIRE_ROCK, GameData.Item.BRIGHT_LIGHTNING_ROCK, GameData.Item.PEAT_MOSS, GameData.Item.WATER_MINT],
		},
		used: [],
	},
	[GameData.Item.ADAMANTITE_ORE]: {
		name: GameData.Item.ADAMANTITE_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12538 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.BETA_QUADRANT, x: 24, y: 6 }, timedNode: true, times: ["12 AM", "12 PM"] }],
		},
		used: [],
	},
	[GameData.Item.BIRCH_LOG]: {
		name: GameData.Item.BIRCH_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12579 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.VOOR_SIAN_SIRAN, x: 27, y: 34 } }],
		},
		used: [],
	},
	[GameData.Item.SPHALERITE]: {
		name: GameData.Item.SPHALERITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 13750 },
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_OCEAN_FISHING, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
			],
		},
		used: [],
	},
	[GameData.Item.TITANIUM_NUGGET]: {
		name: GameData.Item.TITANIUM_NUGGET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12524 },
			recipes: [
				{
					itemMade: GameData.Item.TITANIUM_NUGGET,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 54,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.TITANIUM_ORE, qty: 5 },
						{ item: GameData.Item.IRON_ORE, qty: 1 },
						{ item: GameData.Item.GRENADE_ASH, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 4 },
					],
				},
				{
					itemMade: GameData.Item.TITANIUM_NUGGET,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 54,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.TITANIUM_ORE, qty: 5 },
						{ item: GameData.Item.IRON_ORE, qty: 1 },
						{ item: GameData.Item.GRENADE_ASH, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 4 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SCRAP_SALVAGER, cost: [{ price: 2692, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.DRAVANIAN_SPRING_WATER]: {
		name: GameData.Item.DRAVANIAN_SPRING_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12631 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.SMOLDERING_WASTES, x: 28, y: 31 } }],
		},
		used: [],
	},
	[GameData.Item.DRAVANIAN_MISTLETOE]: {
		name: GameData.Item.DRAVANIAN_MISTLETOE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12943 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.EASTON_EYES, x: 26, y: 9 } }],
			shops: [
				{ shop: GameData.Shop.MOGMUL_MOGBELLY, cost: [{ price: 1893, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 1893, currency: GameData.Currency.GIL }] },
			],
		},
		used: [],
	},
	[GameData.Item.ROYAL_MISTLETOE]: {
		name: GameData.Item.ROYAL_MISTLETOE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 13752 },
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_OCEAN_FISHING, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
			],
		},
		used: [],
	},
	[GameData.Item.EAGLE_FEATHER]: {
		name: GameData.Item.EAGLE_FEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 5358 },
			shops: [
				{ shop: GameData.Shop.SERPENT_QUARTERMASTER, cost: [{ price: 200, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.STORM_QUARTERMASTER, cost: [{ price: 200, currency: GameData.Currency.COMPANY_SEAL }] },
				{ shop: GameData.Shop.FLAME_QUARTERMASTER, cost: [{ price: 200, currency: GameData.Currency.COMPANY_SEAL }] },
			],
		},
		used: [],
	},
	[GameData.Item.DARK_CHESTNUT_LUMBER]: {
		name: GameData.Item.DARK_CHESTNUT_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12581 },
			recipes: [
				{
					itemMade: GameData.Item.DARK_CHESTNUT_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 54,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DARK_CHESTNUT_LOG, qty: 5 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 4 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SCRAP_SALVAGER, cost: [{ price: 2592, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.HALLOWED_WATER]: {
		name: GameData.Item.HALLOWED_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12605 },
			recipes: [
				{
					itemMade: GameData.Item.HALLOWED_WATER,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 56,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.ABALATHIAN_SPRING_WATER, qty: 2 },
						{ item: GameData.Item.ABALATHIAN_MISTLETOE, qty: 2 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 5 },
					],
				},
			],
			shops: [{ shop: GameData.Shop.SCRAP_SALVAGER, cost: [{ price: 2408, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
	[GameData.Item.CLOUD_COTTON_BOLL]: {
		name: GameData.Item.CLOUD_COTTON_BOLL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 13753 },
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_OCEAN_FISHING, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 10, currency: GameData.Currency.SCRIP_COMMON_GATHERER }] },
			],
		},
		used: [],
	},
	[GameData.Item.BLACK_SOIL]: {
		name: GameData.Item.BLACK_SOIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12970 },
			gathering: [
				{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.AVALONIA_FALLEN, x: 17, y: 32 }, timedNode: true, times: ["8 AM"] },
				{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.GREENSWARD, x: 10, y: 37 }, timedNode: true, times: ["4 PM"] },
				{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.PATHS_OF_CONTEMPLATION, x: 7, y: 27 }, timedNode: true, times: ["4 AM"] },
			],
		},
		used: [],
	},
	[GameData.Item.HIGHLAND_WHEAT]: {
		name: GameData.Item.HIGHLAND_WHEAT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12880 },
			gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.CHOCOBO_FOREST, x: 38, y: 20 } }],
		},
		used: [],
	},
	[GameData.Item.BIRCH_SAP]: {
		name: GameData.Item.BIRCH_SAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12891 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.VOOR_SIAN_SIRAN, x: 27, y: 34 } }],
			shops: [
				{ shop: GameData.Shop.LUNA_VANU, cost: [{ price: 468, currency: GameData.Currency.GIL }] },
				{ shop: GameData.Shop.LUNA_VANU, cost: [{ price: 1, currency: GameData.Currency.VANU_WHITEBONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.OVIM_FLEECE]: {
		name: GameData.Item.OVIM_FLEECE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27756 },
			enemies: [GameData.Enemy.OVIM_BILLY, GameData.Enemy.OVIM_NANNY],
			shops: [
				{ shop: GameData.Shop.GRAMSOL, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.HALDEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.PEDRONILLE, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.BRIGHT_FIRE_ROCK]: {
		name: GameData.Item.BRIGHT_FIRE_ROCK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12966 },
			gathering: [
				{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.AVALONIA_FALLEN, x: 25, y: 20 }, timedNode: true, times: ["4 AM"] },
				{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.GREENSWARD, x: 22, y: 38 }, timedNode: true, times: ["12 PM"] },
				{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.PATHS_OF_CREATION, x: 26, y: 17 }, timedNode: true, times: ["8 AM"] },
			],
		},
		used: [],
	},
	[GameData.Item.BRIGHT_LIGHTNING_ROCK]: {
		name: GameData.Item.BRIGHT_LIGHTNING_ROCK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12967 },
			gathering: [
				{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.BLACK_IRON_BRIDGE, x: 25, y: 20 }, timedNode: true, times: ["8 PM"] },
				{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.OK_GUNDU, x: 22, y: 38 }, timedNode: true, times: ["4 PM"] },
			],
		},
		used: [],
	},
	[GameData.Item.PEAT_MOSS]: {
		name: GameData.Item.PEAT_MOSS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12969 },
			gathering: [
				{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.AVALONIA_FALLEN, x: 17, y: 32 }, timedNode: true, times: ["8 AM"] },
				{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.GREENSWARD, x: 10, y: 37 }, timedNode: true, times: ["4 PM"] },
				{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.PATHS_OF_CONTEMPLATION, x: 7, y: 27 }, timedNode: true, times: ["4 AM"] },
			],
		},
		used: [],
	},
	[GameData.Item.WATER_MINT]: {
		name: GameData.Item.WATER_MINT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 33149 },
			gathering: [
				{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.OK_VUNDU_MOK, x: 13, y: 22 }, timedNode: true, times: ["8 PM"] },
				{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.RED_RIM, x: 26, y: 29 }, timedNode: true, times: ["12 AM"] },
			],
		},
		used: [],
	},
	[GameData.Item.ABALATHIAN_SPRING_WATER]: {
		name: GameData.Item.ABALATHIAN_SPRING_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12632 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.VOOR_SIAN_SIRAN, x: 35, y: 31 } }],
		},
		used: [],
	},
	[GameData.Item.ABALATHIAN_MISTLETOE]: {
		name: GameData.Item.ABALATHIAN_MISTLETOE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12944 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.OK_BENDU, x: 40, y: 22 }, timedNode: true, times: ["6AM", "6PM"] }],
			shops: [{ shop: GameData.Shop.PASDEVILLET, cost: [{ price: 3370, currency: GameData.Currency.GIL }] }],
		},
		used: [],
	},
} satisfies Partial<{ [key in GameData.Item]: Info.Item }>;
